import { api } from '~/redux/api/createApi';
import { Uuid } from '~/types/Uuid';

export const useResolveQuestionGroups = ({
  questionGroupIds,
  skip,
}: {
  questionGroupIds: Uuid[];
  skip?: boolean;
}) => {
  const { data: questionGroups, ...rest } =
    api.endpoints.resolveQuestionGroups.useQuery(
      {
        ids: questionGroupIds,
      },
      { skip },
    );

  return { questionGroups, ...rest };
};
